<template>
  <v-container class="application-section" fluid>
    <div class="slider-container">
      <!-- 左側按鈕 -->
      <v-btn @click="prevSlide" class="nav-button left-button" icon>
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>

      <!-- 滑動的應用領域 -->
      <div class="slider-track" :style="sliderStyle">
        <v-col
          v-for="(section, index) in loopedSections"
          :key="index"
          cols="12"
          md="4"
          class="section-col"
        >
          <div class="section-wrapper" @click="navigateToDetail(section.id)">
            <h2 class="section-title">{{ section.title }}</h2>
            <v-card class="section" outlined>
              <img
                :src="section.image"
                alt="Application Section Image"
                class="section-image"
              />
            </v-card>
          </div>
        </v-col>
      </div>

      <!-- 右側按鈕 -->
      <v-btn @click="nextSlide" class="nav-button right-button" icon>
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </v-container>
</template>


<script>
import axios from "axios";

export default {
  name: "ApplicationSection",
  data() {
    return {
      currentIndex: 0, // 初始索引
      sections: [], // 儲存 API 數據
      transitioning: false, // 控制過渡動畫
    };
  },
  computed: {
    loopedSections() {
  if (this.sections.length === 0) return [];
  
  const clonesNeeded = 4; // 確保每次能顯示 4 個
  const startClones = this.sections.slice(-clonesNeeded); // 克隆最後 4 個到最前
  const endClones = this.sections.slice(0, clonesNeeded); // 克隆最前 4 個到最後

  return [...startClones, ...this.sections, ...endClones];
},
sliderStyle() {
  return {
    transform: `translateX(-${(this.currentIndex + 4) * (100 / 4)}%)`, // +4 是因為克隆的前 4 個數據
    transition: this.transitioning ? "transform 0.5s ease" : "none",
  };
},


  },
  methods: {
    async fetchSections() {
      try {
        const baseUrl = process.env.VUE_APP_SERVICE_URL;
        const response = await axios.get(`${baseUrl}/api/v1/searchTaiwan`);
        if (response.data.rtnCode === "0000" && response.data.data.length > 0) {
          this.sections = response.data.data.map((item) => ({
            id: item.id, // 確保包含 id
            title: item.name,
            image: item.image,
          }));
        } else {
          console.error("API 返回錯誤:", response.data.rtnMsg);
        }
      } catch (error) {
        console.error("API 請求失敗:", error);
      }
    },
    prevSlide() {
  if (this.transitioning || this.sections.length <= 1) return;
  this.transitioning = true;
  this.currentIndex--;

  setTimeout(() => {
    if (this.currentIndex < 0) {
      // 滑到克隆的最後部分，重置到原始數據的末尾
      this.currentIndex = this.sections.length - 1;
      this.disableTransition();
    }
    this.enableTransition();
    this.transitioning = false;
  }, 500);
},

nextSlide() {
  if (this.transitioning || this.sections.length <= 1) return;
  this.transitioning = true;
  this.currentIndex++;

  setTimeout(() => {
    if (this.currentIndex >= this.sections.length) {
      // 滑到克隆的開頭部分，重置到原始數據的開頭
      this.currentIndex = 0;
      this.disableTransition();
    }
    this.enableTransition();
    this.transitioning = false;
  }, 500);
},


    navigateToDetail(id) {
    // 使用 Vue Router 的路由導航
    this.$router.push({ name: "CardDetail", params: { id } });
  },
  disableTransition() {
  const track = document.querySelector(".slider-track");
  if (track) track.style.transition = "none";
},

enableTransition() {
  const track = document.querySelector(".slider-track");
  if (track) track.style.transition = "transform 0.5s ease";
},


  },
  created() {
  this.fetchSections().then(() => {
    if (this.sections.length > 0) {
      this.currentIndex = 0; // 設置為克隆的數據後第一個原始數據的索引
    }
  });
},

};
</script>




<style scoped>
.application-section {
  max-width: 100%;
  padding: 2%;
  margin: 0 auto;
}

.slider-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.slider-track {
  display: flex;
  transition: transform 0.5s ease;
  width: calc(100% * (4 + 2)); /* 4 原始資料 + 2 虛擬資料 */
}




.section-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  cursor: pointer; /* 鼠標移上去變成點選狀態 */
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* 添加過渡效果 */
}

.section-wrapper:hover {
  transform: translateY(-5px); /* 向上浮動一點 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* 增加陰影效果 */
  background-color: #f9f9f9; /* 背景色變化 */
  border-radius: 8px; /* 確保邊角圓滑 */
}


.section-title {
  font-size: 1.2em;
  color: #333;
  margin-bottom: 5px;
  margin-left: 5px;
}
.section-col {
  flex: 0 0 25%; /* 每個卡片占 1/4 寬度 */
  max-width: 25%;
  box-sizing: border-box;
  padding: 0 1%;
}
.section {
  width: 100%;
  height: 300px; /* 固定框架高度 */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  background-color: #ffffff;
  /* border: 1px solid #d0d0d0; */
  border-radius: 4%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.section-image {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 確保圖片完整顯示 */
  object-position: center;
  background-color: #f5f5f5; /* 設定背景色，避免空白感 */
}


.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: #f5f5f5;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  color: #246531;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1;
}

.nav-button:hover {
  background-color: #d8f3dc; /* 淺綠色 */
}

.left-button {
  left: 10px;
}

.right-button {
  right: 10px;
}



</style>

